module.exports = __webpack_public_path__ + "img/jm.7c660277.svg";